import messages from "messages";

type TCPTCode = {
  id: string;
  type: "BASIC" | "ADDON";
  description: string;
};

/**
 * service codes
 * @see https://therathink.com/mental-health-cpt-codes/
 */
export const CPT_CODES: TCPTCode[] = [
  {
    id: "00000",
    type: "BASIC",
    description: "Initial Consultation - No Charge",
  },
  {
    id: "0591T",
    type: "BASIC",
    description:
      "Health and Well-Being Coaching face-to-face; individual, initial assessment",
  },
  {
    id: "0592T",
    type: "BASIC",
    description: "Individual, follow-up session, at least 30 minutes",
  },
  {
    id: "0593T",
    type: "BASIC",
    description: "Group (two or more individuals), at least 30 minutes",
  },
  { id: "40819", type: "BASIC", description: "Frenectomy (Labial or Buccal)" },
  { id: "41010", type: "BASIC", description: "Frenotomy (Lingual)" },
  {
    id: "90791",
    type: "BASIC",
    description: "Psychiatric Diagnostic Evaluation",
  },
  {
    id: "90792",
    type: "BASIC",
    description: "Psychiatric Diagnostic Evaluation with Medical",
  },
  {
    id: "90832",
    type: "BASIC",
    description: "Psychotherapy, 30 minutes (16 -37 minutes).",
  },
  {
    id: "90834",
    type: "BASIC",
    description: "Psychotherapy, 45 minutes (38 -52 minutes).",
  },
  {
    id: "90837",
    type: "BASIC",
    description: "Psychotherapy, 60 minutes (53 minutes and over).",
  },
  {
    id: "90839",
    type: "BASIC",
    description: "Psychotherapy for Crisis, 60 min",
  },
  { id: "90845", type: "BASIC", description: "Psychoanalysis" },
  {
    id: "90846",
    type: "BASIC",
    description: "Family or couples psychotherapy, without patient present.",
  },
  {
    id: "90847",
    type: "BASIC",
    description: "Family or couples psychotherapy, with patient present.",
  },
  {
    id: "90849",
    type: "BASIC",
    description: "Multiple-family group psychotherapy",
  },
  {
    id: "90853",
    type: "BASIC",
    description: "Group Psychotherapy (not family).",
  },
  {
    id: "90868",
    type: "BASIC",
    description:
      "Telephone therapy (non-psychiatrist) – limit 3 units/hours per application.",
  },
  {
    id: "90875",
    type: "BASIC",
    description:
      "Individual psychophysiological therapy incorporating biofeedback training by any modality (face-to-face with the patient), with psychotherapy (eg, insight oriented, behavior modifying or supportive psychotherapy); 30 minutes",
  },
  {
    id: "90876",
    type: "BASIC",
    description:
      "Individual psychophysiological therapy incorporating biofeedback training by any modality (face-to-face with the patient), with psychotherapy (eg, insight oriented, behavior modifying or supportive psychotherapy); 45 minutes",
  },
  {
    id: "90885",
    type: "BASIC",
    description:
      "Psychiatric evaluation of records, reports, psychometric and/or projective tests, and other accumulated data for medical diagnostic purposes",
  },
  { id: "90887", type: "BASIC", description: "Collateral Visit" },
  {
    id: "90899",
    type: "BASIC",
    description: "Unlisted psychiatric service or procedure",
  },
  { id: "90901", type: "BASIC", description: "Biofeedback training" },
  {
    id: "92507",
    type: "BASIC",
    description:
      "Treatment of speech, language, voice, communication, and/or auditory processing disorder; individual",
  },
  { id: "92520", type: "BASIC", description: "Laryngeal function studies" },
  { id: "92521", type: "BASIC", description: "Evaluation of speech fluency" },
  {
    id: "92522",
    type: "BASIC",
    description: "Evaluation of speech production",
  },
  {
    id: "92523",
    type: "BASIC",
    description:
      "Evaluation of speech sound production; with evaluation of language comprehension and expression (e.g., receptive and expressive language)",
  },
  {
    id: "92524",
    type: "BASIC",
    description: "Behavioral and qualitative analysis of voice and resonance",
  },
  {
    id: "92526",
    type: "BASIC",
    description:
      "Treatment of Swallowing Dysfunction and/or Oral Function for Feeding",
  },
  {
    id: "92610",
    type: "BASIC",
    description: "Evaluation of oral and pharyngeal swallowing function",
  },
  {
    id: "93347",
    type: "BASIC",
    description: "Established Patient E/M Home visit - 15 minutes",
  },
  { id: "95806", type: "BASIC", description: "Sleep study, unattended" },
  {
    id: "95999",
    type: "BASIC",
    description: "Neuromuscular procedure, unlisted",
  },
  {
    id: "96103",
    type: "BASIC",
    description:
      "Psychological testing by a computer, including time for the psychologist's interpretation and reporting",
  },
  { id: "96105", type: "BASIC", description: "Assessment of Aphasia" },
  {
    id: "96111",
    type: "BASIC",
    description: "Developmental Testing, Extended",
  },
  { id: "96115", type: "BASIC", description: "Neurobehavioral Status Exam" },
  {
    id: "96116",
    type: "BASIC",
    description: "Neurobehavioral status exam, first hour",
  },
  {
    id: "96120",
    type: "BASIC",
    description:
      "Neuropsychological testing by a computer, including time for the psychologist's interpretation and reporting",
  },
  {
    id: "96121",
    type: "BASIC",
    description: "Neurobehavioral status exam, each additional hour",
  },
  {
    id: "96125",
    type: "BASIC",
    description: "Standardized cognitive performance testing",
  },
  {
    id: "96127",
    type: "BASIC",
    description:
      "Brief emotional/behavioral assessment (eg, depression inventory, attention-deficit/hyperactivity disorder [ADHD] scale), with scoring and documentation, per standardized instrument",
  },
  {
    id: "96130",
    type: "BASIC",
    description:
      "Psychological testing, evaluation by a psychologist, first hour",
  },
  {
    id: "96131",
    type: "BASIC",
    description:
      "Psychological testing, evaluation by a psychologist, each additional hour",
  },
  {
    id: "96132",
    type: "BASIC",
    description:
      "Neuropsychological testing, evaluation by a psychologist, first hour",
  },
  {
    id: "96133",
    type: "BASIC",
    description:
      "Neuropsychological testing, evaluation by a psychologist, each additional hour",
  },
  {
    id: "96136",
    type: "BASIC",
    description:
      "Psychological or neuropsychological test administration and scoring by a psychologist, first 30 minutes",
  },
  {
    id: "96137",
    type: "BASIC",
    description:
      "Psychological or neuropsychological test administration and scoring by a psychologist, each additional 30 minutes",
  },
  {
    id: "96138",
    type: "BASIC",
    description:
      "Psychological or neuropsychological test, by technician, first 30 minutes",
  },
  {
    id: "96139",
    type: "BASIC",
    description:
      "Psychological or neuropsychological test, by technician, each additional 30 minutes",
  },
  {
    id: "96156",
    type: "BASIC",
    description: "Health behavior assessment or re-assessment",
  },
  {
    id: "96158",
    type: "BASIC",
    description: "Health behavior intervention, individual, initial 30 minutes",
  },
  {
    id: "96164",
    type: "BASIC",
    description:
      "Health behavior intervention, group (2 or more patients), initial 30 minutes",
  },
  {
    id: "96167",
    type: "BASIC",
    description:
      "Health behavior intervention, family, with patient present, initial 30 minutes",
  },
  {
    id: "96170",
    type: "BASIC",
    description:
      "Health behavior intervention, family, without patient present, initial 30 minutes",
  },
  {
    id: "97002",
    type: "BASIC",
    description: "Office Re-evaluation with new referral/prescription",
  },
  { id: "97026", type: "BASIC", description: "Infrared Therapy" },
  {
    id: "97032",
    type: "BASIC",
    description:
      "Application of a modality to 1 or more areas; electrical stimulation (manual), each 15 minutes",
  },
  { id: "97035", type: "BASIC", description: "Ultrasound therapy" },
  { id: "97110", type: "BASIC", description: "Therapeutic exercises" },
  { id: "97112", type: "BASIC", description: "Neuromuscular re-education" },
  {
    id: "97129",
    type: "BASIC",
    description:
      "Therapeutic interventions that focus on cognitive function; initial 15 minutes",
  },
  {
    id: "97130",
    type: "BASIC",
    description:
      "Therapeutic interventions that focus on cognitive function; each additional 15 minutes",
  },
  {
    id: "97151",
    type: "BASIC",
    description: "Under Adaptive Behavior Assessment Procedures",
  },
  {
    id: "97530",
    type: "BASIC",
    description:
      "Therapeutic activities, direct (one-on-one) patient contact (use of dynamic activities to improve functional performance), each 15 minutes",
  },
  {
    id: "97535",
    type: "BASIC",
    description:
      "Self-care/home management training (eg, activities of daily living (ADL) and compensatory training, meal preparation, safety procedures, and instructions in use of assistive technology devices/adaptive equipment) direct one-on-one contact, each 15 minutes",
  },
  {
    id: "97750",
    type: "BASIC",
    description:
      "Physical performance test for measurement (eg. musculoskeleteal, functional capacity) with a written report, each 15 mins",
  },
  { id: "97770", type: "BASIC", description: "Cognitive Rehabilitation" },
  {
    id: "97802",
    type: "BASIC",
    description:
      "Medical nutrition therapy; initial assessment & intervention, individual, face-to-face with the patient, each 15 minutes",
  },
  {
    id: "97803",
    type: "BASIC",
    description:
      "Re-assessment & intervention, individual, face-to-face with the patient, each 15 minutes",
  },
  {
    id: "97804",
    type: "BASIC",
    description: "Group (2 or more individual(s)), each 30 minutes",
  },
  { id: "99024", type: "BASIC", description: "Post-op follow up visit" },
  { id: "99071", type: "BASIC", description: "Patient education materials" },
  {
    id: "99072",
    type: "BASIC",
    description:
      "Additional supplies, materials, and clinical staff time over and above those usually included in an office visit or other nonfacility service(s), when performed during a Public Health Emergency, as defined by law, due to infectious respiratory disease",
  },
  {
    id: "99080",
    type: "BASIC",
    description:
      "Special reports such as insurance forms, more than the information conveyed in the usual medical communications or standard reporting form",
  },
  {
    id: "99201",
    type: "BASIC",
    description:
      "Evaluation/Management Limited. Presenting problems are self-limited or minor: requires a problem-focused history, problem-focused examination, and straightforward medical decision-making.",
  },
  {
    id: "99202",
    type: "BASIC",
    description: "Level 2 new patient office visit",
  },
  {
    id: "99203",
    type: "BASIC",
    description: "Level 3 new patient office visit",
  },
  {
    id: "99204",
    type: "BASIC",
    description: "Level 4 new patient office visit",
  },
  {
    id: "99205",
    type: "BASIC",
    description: "Level 5 new patient office visit",
  },
  {
    id: "99211",
    type: "BASIC",
    description:
      "Evaluation/Management Minimal. Presenting problems are minimal. The provider typically spends five minutes face to face with the patient.",
  },
  { id: "99212", type: "BASIC", description: "Level 2 office visit" },
  { id: "99213", type: "BASIC", description: "Level 3 office visit" },
  { id: "99214", type: "BASIC", description: "Level 4 office visit" },
  { id: "99215", type: "BASIC", description: "Level 5 office visit" },
  {
    id: "99236",
    type: "BASIC",
    description:
      "Observation or inpatient hospital care, for the evaluation and management of a patient",
  },
  { id: "99243", type: "BASIC", description: "Level 3 office consultation" },
  {
    id: "99244",
    type: "BASIC",
    description: "Comprehensive consultation (Level 4)",
  },
  {
    id: "99327",
    type: "BASIC",
    description:
      "Under New Patient Domiciliary, Rest Home (eg, Boarding Home), or Custodial Care Services",
  },
  {
    id: "99336",
    type: "BASIC",
    description:
      "Under Established Patient Domiciliary, Rest Home (eg, Boarding Home), or Custodial Care Services",
  },
  {
    id: "99341",
    type: "BASIC",
    description: "New Patient E/M Home Visit - 20 minutes face-to-face",
  },
  {
    id: "99342",
    type: "BASIC",
    description: "New Patient E/M Home Visit - 30 minutes face-to-face",
  },
  { id: "99343", type: "BASIC", description: "Home Service, New Patient" },
  {
    id: "99344",
    type: "BASIC",
    description: "New Patient E/M Home Visit - 60 minutes face-to-face",
  },
  {
    id: "99348",
    type: "BASIC",
    description: "Established Patient E/M Home visit - 25 minutes",
  },
  {
    id: "99349",
    type: "BASIC",
    description: "Established Patient E/M Home visit - 40 minutes",
  },
  {
    id: "99350",
    type: "BASIC",
    description: "Established Patient E/M Home visit - 60 minutes",
  },
  {
    id: "99361",
    type: "BASIC",
    description:
      "Medical conference by a physician with interdisciplinary team of health professionals or representatives of community agencies to coordinate patient care while patient is not present",
  },
  {
    id: "99362",
    type: "BASIC",
    description:
      "Medical conference by a physician with interdisciplinary team of health professionals or representatives of community agencies to coordinate patient care while patient is not present",
  },
  {
    id: "99401",
    type: "BASIC",
    description: "Preventive medicine individual counseling - 15 minutes",
  },
  {
    id: "99403",
    type: "BASIC",
    description: "Preventive medicine individual counseling - 45 minutes",
  },
  {
    id: "99404",
    type: "BASIC",
    description:
      "Preventive medicine counseling and/or risk factor reduction intervention(s) provided to an individual (separate procedure)",
  },
  {
    id: "99408",
    type: "BASIC",
    description:
      "Alcohol and/or substance abuse structured screening and brief intervention services; 15 to 30 minutes",
  },
  {
    id: "99409",
    type: "BASIC",
    description:
      "Alcohol and/or substance abuse structured screening and brief intervention services; greater than 30 minutes",
  },
  {
    id: "99423",
    type: "BASIC",
    description:
      "Online digital evaluation and management service, for an established patient, for up to 7 days, cumulative time during the 7 days; 21 or more minutes.",
  },
  {
    id: "99441",
    type: "BASIC",
    description:
      "Telephone evaluation and management service by a physician or other qualified health care professional, 5-10 minutes",
  },
  {
    id: "99442",
    type: "BASIC",
    description:
      "Telephone evaluation and management service by a physician or other qualified health care professional, 11-20 minutes",
  },
  {
    id: "99443",
    type: "BASIC",
    description:
      "Telephone evaluation and management service by a physician or other qualified health care professional, 21-30 minutes",
  },
  {
    id: "G2212",
    type: "BASIC",
    description:
      "Prolonged office or other outpatient evaluation and management service(s) beyond the maximum required time of the primary procedure which has been selected using total time on the date of the primary service; each additional 15 minutes by the physician or",
  },
  {
    id: "H0015",
    type: "BASIC",
    description:
      "Alcohol and/or drug services; intensive outpatient (treatment program that operates at least 3 hours/day and at least 3 days/week and is based on an individualized treatment plan), including assessment, counseling; crisis intervention, and activity therap",
  },
  { id: "S9443", type: "BASIC", description: "Lactation Classes" },
  {
    id: "S9470",
    type: "BASIC",
    description: "Nutritional counseling, dietitian visit",
  },
  {
    id: "T2023",
    type: "BASIC",
    description: "Targeted case management; per month",
  },
  { id: "Y9505", type: "BASIC", description: "Group Therapy, 60 min" },
  { id: "Y9506", type: "BASIC", description: "Group Therapy, 90 min" },
  { id: "Y9507", type: "BASIC", description: "Group Therapy, 120 min" },
  { id: "+90785", type: "ADDON", description: "Interactive Complexity Add-on" },
  { id: "+90833", type: "ADDON", description: "Psychotherapy Add-on, 30 min" },
  { id: "+90836", type: "ADDON", description: "Psychotherapy Add-on, 45 min" },
  { id: "+90838", type: "ADDON", description: "Psychotherapy Add-on, 60 min" },
  {
    id: "+90840",
    type: "ADDON",
    description: "Additional Crisis Therapy, 30 min",
  },
  { id: "+90863", type: "ADDON", description: "Pharmacologic Mgmt Add-on" },
  {
    id: "+99354",
    type: "ADDON",
    description: "Prolonged service in the office/outpatient setting",
  },
  { id: "+Y9991", type: "ADDON", description: "Supplemental Bilingual A Rate" },
  { id: "+Y9992", type: "ADDON", description: "Supplemental Bilingual B Rate" },
  {
    id: "+99051",
    type: "ADDON",
    description:
      "Service provided in the office during regularly scheduled evening, weekend, or holiday office hours",
  },
  {
    id: "+99355",
    type: "ADDON",
    description: "Prolonged service, each additional 30 minutes",
  },
  {
    id: "+97532",
    type: "ADDON",
    description: "Cognitive skills development (15 minutes)",
  },
  {
    id: "+99402",
    type: "ADDON",
    description: "Preventative Counseling, 30 min",
  },
  { id: "+s9443", type: "ADDON", description: "Lactation Class, Per Session" },
  {
    id: "+99050",
    type: "ADDON",
    description:
      "Service provided in the office during regularly scheduled evening, weekend, or holiday office hours",
  },
  {
    id: "+96159",
    type: "ADDON",
    description:
      "Health behavior intervention, individual, each additional 15 minutes",
  },
  {
    id: "+96165",
    type: "ADDON",
    description:
      "Health behavior intervention, group (2 or more patients), each additional 15 minutes",
  },
  {
    id: "+96168",
    type: "ADDON",
    description:
      "Health behavior intervention, family, with patient present, each additional 15 minutes",
  },
  {
    id: "+96171",
    type: "ADDON",
    description:
      "Health behavior intervention, family, without patient present, each additional 15 minutes",
  },
  {
    id: "97165",
    type: "BASIC",
    description: "Occupational therapy evaluation, low complexity",
  },
  {
    id: "97166",
    type: "BASIC",
    description: "Occupational therapy evaluation, moderate complexity",
  },
  {
    id: "97167",
    type: "BASIC",
    description: "Occupational therapy evaluation, high complexity",
  },
  {
    id: "97168",
    type: "BASIC",
    description: "Occupational therapy re-evaluation",
  },
  {
    id: "97537",
    type: "BASIC",
    description:
      "Community/Work Reintegration Training, direct one-on-one contact, each 15 minutes",
  },
  {
    id: "99199",
    type: "BASIC",
    description: "Unlisted special service, procedure or report",
  },
];

export const CPT_TYPE_LABELS = Object.freeze({
  BASIC: messages.practiceServices,
  ADDON: messages.addonServices,
});

export const getDefaultCPTCodes = (
  lengthInMs: number,
  isGroupSession: boolean,
) => {
  /**
   * if it's 1-1 appointment, choose among 90832, 90834, 90837 based on session length
   * if it's a group session, use 90853
   * @see https://therathink.com/mental-health-cpt-codes/
   * @see https://orchidhealth.atlassian.net/browse/OIM-792?filter=-1
   */
  if (isGroupSession) {
    return ["90853"];
  }

  if (lengthInMs <= 37 * 60 * 1000) {
    return ["90832"];
  }

  if (lengthInMs <= 52 * 60 * 1000) {
    return ["90834"];
  }

  return ["90837"];
};
